/**
 * Language: English.
 */
export default {
    time: {
        openingHoursTitle: "Opening hours",
        at: "at",
        opensToday: "Opens today",
        opens: "Opens",
        open24_7: "Open 24/7",
        closed: "Closed",
        openUntil: "Open until",
        daily: "Daily opened",
        month: [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ],
        monthAbbr: [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ],
        dayOfWeek: [
            'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
        ],
        dayOfWeekAbbr: [
            'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'
        ],
        eventCountdown: "Next event in",
        days: "days",
        hours: "hours",
        tomorrow: "Next event tommorow",
        today: "Today"
    },
    search: {
        placeholder: "Search a location...",
        submitLabel: "Search",
        clearLabel: "Clear Search",
        yourLocation: "Your location",
    },
    filtering: {
        servicesTitle: "Filters",
        services: {
            AR: 'Archery',
            ARG: 'Artistic Gymnastics',
            ARS: 'Artistic Swimming',
            ATH: 'Athletics',
            BDM: 'Badminton',
            BKB: 'Basketball',
            BK3: '3x3 Basketball',
            BV: 'Beach Volleyball',
            BOX: 'Boxing',
            BKG: 'Breaking',
            CSL: 'Canoe Slalom',
            CSP: 'Canoe Sprint',
            BMF: 'Cycling BMX Freestyle',
            BMX: 'Cycling BMX Racing',
            MTB: 'Cycling Mountain Bike',        
            CRD: 'Cycling Road',
            CTR: 'Cycling Track',
            DIV: 'Diving',
            EQU: 'Equestrian',
            FEN: 'Fencing',
            FB: 'Football',
            GLF: 'Golf',
            HBL: 'Handball',
            HOC: 'Hockey',
            JUD: 'Judo',
            OWS: 'Marathon Swimming',
            MPN: 'Modern Pentathlon',
            GRY: 'Rhythmic Gymnastics',
            ROW: 'Rowing',
            RU7: 'Rugby Sevens',
            SAL: 'Sailing',
            SHO: 'Shooting',
            SKB: 'Skateboarding',
            CLB: 'Sport Climbing',
            SRF: 'Surfing',
            SWM: 'Swimming',
            TTE: 'Table Tennis',
            TKW: 'Taekwondo',
            TEN: 'Tennis',
            GTR: 'Trampoline Gymnastics',
            TRI: 'Triathlon',
            VVO: 'Volleyball',
            WPO: 'Water Polo',
            WLF: 'Weightlifting',
            WRE: 'Wrestling'
        }
    },
    stores: {
        cta: {
            call: "Call",
            directions: "Directions",
            website: "Website"
        },
        messages: {
            initialHeader: "Start by searching a locality to display nearby sites",
            emptyHeader: "No results returned",
            initialBody: "or click on the Map to select a site",
            emptyBody: "Please Search a locality elsewhere or unselect your filters"
        },
        types: {
            major: "Celebration site",
            minor: "Visited place"
        },
        name: {
            Stage: "Stage"
        }
    },
    directions: {
        avoidOptions: {
            highways: 'Highways',
            tolls: 'Tolls',
            ferries: 'Ferries'
        },
        avoidTransitOptions: {
            train: 'Train',
            bus: 'Bus',
            ferries: 'Ferries',
            aerial: 'Aerial'
        },
        unitOptions: {
            METRIC: 'km',
            IMPERIAL: 'miles'
        },
        options: "Route options",
        avoid: "Avoid",
        units: "Distance units",
        messages: {
            initialBody: "Search an origin and destination to see available routes and time travel.",
            error: "Sorry, we could not calculate driving directions",
            from: "from",
            to: "to",
            forTravelMode: "for the travel mode",
            via: "through",
            details: "Details",
            withoutTraffic: "without traffic",
            openGoogleMaps: "open in google maps",
            take: "Take",
            walk: "Walk",
            the: "the"
        },
        transit : {
            "train": "train",
            "bus": "bus",
            "ferries": "ferry",
            "aerial": "aérien",
            "tram": "tram",
            "rail": "train",
        }
    },
    errors: {
        loadingLibrary: "failed to load the {library} script",
        geolocationFailed: "User Geolocation failed",
        apiErrors: {
            "401": "Unauthorized",
            "403": "Forbidden",
            "429": "Too many requests",
            "500": "Internal server error",
            other: "An unexpected server error occurred"
        }
    },
    map: {
        showRoute: 'Show Route',
    }
};
